// extracted by mini-css-extract-plugin
module.exports = {"svgimage":"SvgInline_svgimage_3uGHF"};